import React, { useState } from 'react'
import { useGetCategoriesListQuery } from '../Service/extendedCategoriesApi';
import { Category, CategoryListRequest } from '../Types/category.types';
import { useDeleteCategoryMutation } from '../Service/categoriesApi';

import { CategoriesRoutes } from '../../../Router/path';
import DataTable, { ColumnConfig } from '../../Shared/Components/DataTable';
import { useNavigate } from 'react-router-dom';
import ActionButtons from '../../Shared/Components/ActionButtons';
import CategorySearchForm from '../Components/CategorySearchForm';
import CustomCard from '../../Shared/Components/CustomCard/CustomCard';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import Status from '../../Shared/Components/Status/Status';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';

const Categories = () => {
    const [filters, setFilters] = useState({
        name: "",
        published: "",
    })
    const [page, setPage] = useState(0); // zero-based index
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>([]);

    const { data, isLoading, isError, error } = useGetCategoriesListQuery({
        searchPhrase: filters.name,
        pageNumber: page + 1, // API 1-based
        pageSize: rowsPerPage,
    } as CategoryListRequest); // Replace 'any' with the appropriate type for your request

    const [deleteCategory, statusDelete] = useDeleteCategoryMutation();

    const handleDeleteSelected = useDeleteSelectedItems<number>(
        selectedCategoryIds,
        (id) => deleteCategory(id).unwrap(),
        () => setSelectedCategoryIds([])
    );

    const handleCreate = useCreateRedirect(CategoriesRoutes.create)
    const columns: ColumnConfig<Category>[] = [
        { key: "id", label: "ID" },
        { key: "name", label: "Nazwa" },
        {
            key: "published",
            label: "Opublikowany",
            render: (row) => (
                <input type="checkbox" disabled checked={row.published} />
            ),
        },
    ];
    const navigate = useNavigate()
    return (
        <>
            <CustomCard
                icon={<InfoIcon fontSize="large" color="primary" />}
                title="Kategorie"
                subheader="Zarządzaj dostępnymi kategoriami w systemie"
                sx={{ mb: 4 }}
            >
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" gutterBottom>
                        Na tej stronie możesz dodać, edytować i publikować Kategorie.
                        Aby opublikować kategorię, najpierw musisz wprowadzić podstawowe informacje
                        i dodać co najmniej jedno zdjęcie.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Skorzystaj z przycisków poniżej, żeby dodać nową kategorię, usunąć zaznaczone lub wybierz kategorię z listy,
                        aby ją edytować.
                    </Typography>
                </Box>
            <ActionButtons
                onCreate={handleCreate}
                onDeleteSelected={handleDeleteSelected}
            />

            <CategorySearchForm onSearch={setFilters} />
            </CustomCard>
            <CustomCard>
            <DataTable
                columns={columns}
                data={data?.items || []}
                isLoading={isLoading}
                isError={isError}
                errorMessage={(error as any)?.data?.message}
                getRowId={(row) => row.id}
                onEdit={(id) => {
                    const item = data?.items.find(item => item.id === id);
                    if (item) {
                        navigate(CategoriesRoutes.update.replace(":categoryId", item.id.toString()));
                    }
                }}
                page={page}
                rowsPerPage={rowsPerPage}
                totalCount={data?.totalCount || 0}
                onPageChange={(newPage) => setPage(newPage)}
                onRowsPerPageChange={(newSize) => {
                    setRowsPerPage(newSize);
                    setPage(0);
                }}
                selected={selectedCategoryIds}
                onSelectionChange={(selectedIds) => {
                    setSelectedCategoryIds(selectedIds);
                }}
            />
            </CustomCard>
            <Status statusDelete={statusDelete} />
        </>
    )
}

export default Categories